import React from "react"
import { ThemeProvider } from '@mui/material/styles'
import getTheme from './FcThemeSwitcher'
import { useSelector } from 'react-redux'

import { currentCompany } from '../components/company/companySlice'
import { userColorMode, } from '../components/user/userSlice'

export const FcThemeProvider = (props) => {
    const { children } = props

    var currentcompany = useSelector(currentCompany)
    var usercolormode = useSelector(userColorMode)

    const theme = getTheme(currentcompany.themename, usercolormode)

    return (
        <ThemeProvider theme={theme}>
            {children}
        </ThemeProvider>
    )
}
